export const DOMAIN_NAME = 'Localization';
export const ACTIONS_GROUP = 'user_actions';
export const ACTIONS_SUB_GROUP = 'website_actions';
export const CLICK_ACTION_TYPE = 'click';
